import { ADD_IDS, } from '../reducers/payment';

function addIdsType(ids: number[]) {
    return {
        type: ADD_IDS,
        payload: ids
    };
}

export function addIds(ids: number[]) {
    return (dispatch: any) => {
        return new Promise<void>((ok, error) => {
            localStorage.setItem('ids', JSON.stringify(ids));
            dispatch(addIdsType(ids));
            ok();
        });
    }
}
